export enum ErrorLevelEnum {
  WARNING = "WARNING",
  FATAL = "FATAL",
}
